import React, { useState, useEffect, useMemo } from 'react';

const CrossfadeImages = ({ images, duration = 3000, className }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const animate = images.length > 1;

  const imageArr = useMemo(() => images.map((image) => image.image.file.url), []);

  useEffect(() => {
    let interval;
    if (animate) {
      interval = setInterval(() => {
        setIsVisible(false);
        setTimeout(() => {
          setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
          setIsVisible(true);
        }, 1000); // Fade out duration should match CSS transition duration
      }, duration);
    }
    return () => animate && clearInterval(interval);
  }, [currentIndex, images.length, duration]);

  return (
    <div className={`crossfade-image image-slider ${className}`}>
      {imageArr.map((image, index) => (
        <img
          loading="eager"
          key={index}
          src={image}
          alt={`Slide ${index}`}
          className={`slider-image ${
            index === currentIndex && isVisible ? 'opacity-1' : 'opacity-0'
          } transition-opacity duration-1000 ease-in-out`}
        />
      ))}
    </div>
  );
};

export default CrossfadeImages;
